import React from 'react';

import cn from 'classnames';
import { string, shape, node } from 'prop-types';

import Button from 'components/Common/Buttons/ButtonV2';

import s from './SupportLink.css';

export default class SupportLink extends React.Component {
  render() {
    const {
      variant,
      text,
      buttonVariant,
      buttonColor,
      url,
      hyperlinkColor,
      style,
      className,
    } = this.props;
    const hyperlinkClass = {
      black: s.blackHyperlink,
      blue: s.blueHyperlink,
      green: s.greenHyperlink,
    }[hyperlinkColor];
    return (
      <>
        {variant === 'button' ? (
          <Button
            variant={buttonVariant}
            color={buttonColor}
            onClick={() => window.open(url, '_blank')}
            style={style}
            aria-label="Need help?"
          >
            {text}
          </Button>
        ) : null}
        {variant === 'hyperlink' ? (
          <div
            role="button"
            tabIndex={0}
            onClick={() => window.open(url, '_blank')}
            className={cn(className, s.hyperlink, hyperlinkClass)}
            style={style}
            aria-label="Need help?"
          >
            {text}
          </div>
        ) : null}
      </>
    );
  }
}

SupportLink.propTypes = {
  buttonVariant: string,
  buttonColor: string,
  hyperlinkColor: string,
  style: shape({}),
  variant: string.isRequired,
  text: node.isRequired,
  url: string.isRequired,
  className: string,
};

SupportLink.defaultProps = {
  buttonVariant: 'filled',
  buttonColor: 'primary',
  hyperlinkColor: 'blue',
  style: {},
  className: undefined,
};
